import { render, staticRenderFns } from "./FieldType1.vue?vue&type=template&id=1d9901da&scoped=true"
import script from "./FieldType1.vue?vue&type=script&lang=js"
export * from "./FieldType1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9901da",
  null
  
)

export default component.exports